module.exports = __webpack_public_path__ + "img/2010.11-2.09ad0cbf.jpg";